import { gql } from '@apollo/client';

export const GET_MESSAGE_COUNT = gql`
  query messages($messageQuery: MessageQuery) {
    messages(input: $messageQuery) {
      size
    }
  }
`;
